import { render, staticRenderFns } from "./employeePanel.vue?vue&type=template&id=54dbda0c&scoped=true"
import script from "./employeePanel.vue?vue&type=script&lang=js"
export * from "./employeePanel.vue?vue&type=script&lang=js"
import style0 from "./employeePanel.vue?vue&type=style&index=0&id=54dbda0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dbda0c",
  null
  
)

export default component.exports